export const interseccion = (arr1, arr2) => {
  const set2 = new Set(arr2);
  const uniqueArr1 = Array.from(new Set(arr1)); // Ensure arr1 has unique values
  return uniqueArr1.filter(item => set2.has(item));
};

export default {
  interseccion
};
